"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TimerTimer = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

var TimerTimer = (_class = (_temp =
/*#__PURE__*/
function () {
  (0, _createClass2.default)(TimerTimer, [{
    key: "isFinished",
    // the number of milliseconds we started at and used to offset against the current milliseconds
    // number of milliseconds to finish at
    get: function get() {
      return this.finishedAt != null;
    }
  }]); // constructor(secondsToRun: number = 0, onComplete: Function) {

  function TimerTimer() {
    (0, _initializerDefineProperty2.default)(this, "startTime", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "finishTime", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "startMilliseconds", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "currentMilliseconds", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "finishedAt", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "secondsToRun", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "msToRun", _descriptor7, this);
    this.timer = void 0;
    this.onComplete = void 0;
    this.initStartTime(); // this.updateTime();
    // runInAction(() => {
    //   this.onComplete = onComplete;
    // });
    // autorun(() => {
    //   this.initStartTime();
    //   console.log('TimerStore-secondsToRun: ' + this.secondsToRun)
    // });
  }

  var _proto = TimerTimer.prototype;

  _proto.setSecondsToRun = function setSecondsToRun(secondsToRun) {
    this.setMsToRun(secondsToRun * 1000);
  };

  _proto.setMsToRun = function setMsToRun(msToRun) {
    this.msToRun = msToRun; // if (!this.isFinished()) {
    // this.initStartTime();
    // }
  };

  _proto.initStartTime = function initStartTime() {
    this.finishedAt = null;
    this.startMilliseconds = this.msToRun;
    this.currentMilliseconds = this.startMilliseconds;
  };

  _proto.start = function start(secondsToRun) {
    var _this = this;

    if (secondsToRun === void 0) {
      secondsToRun = 0;
    }

    this.finishedAt = null;
    this.startTime = performance.now(); // this.initStartTime();

    this.timer = setInterval(function () {
      return _this.updateTime();
    }, 200);
  };

  _proto.pause = function pause() {
    this.startMilliseconds = this.updateTime();
    clearInterval(this.timer);
  };

  _proto.updateTime = function updateTime() {
    var now = Math.max(0, this.startMilliseconds - (performance.now() - this.startTime));
    this.currentMilliseconds = now;

    if (now === 0) {
      this.finishedAt = new Date();
      clearInterval(this.timer); // this.start = function() {};

      if (this.onComplete) {
        this.onComplete();
      }
    }

    return now;
  };

  _proto.reset = function reset() {
    this.initStartTime();
    this.startTime = performance.now();
  };

  return TimerTimer;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "startTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "finishTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "startMilliseconds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currentMilliseconds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "finishedAt", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFinished", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFinished"), _class.prototype), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "secondsToRun", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "msToRun", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSecondsToRun", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSecondsToRun"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setMsToRun", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setMsToRun"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initStartTime", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initStartTime"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "start", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "start"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pause", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pause"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateTime", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTime"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype)), _class);
exports.TimerTimer = TimerTimer;